(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__gaPriceVariantSync) return;
    window.__gaPriceVariantSync = true;

    function readMap(host) {
      var node = host.querySelector('script.ga-price-data');
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (e) {
        return null;
      }
    }

    function apply(priceEl, now, was) {
      var nowEl = priceEl.querySelector('.ga-price__now');
      var wasEl = priceEl.querySelector('.ga-price__was');
      if (nowEl && now) nowEl.textContent = now;
      if (!wasEl) return;
      if (was) {
        wasEl.textContent = was;
        wasEl.removeAttribute('hidden');
      } else {
        wasEl.textContent = '';
        wasEl.setAttribute('hidden', '');
      }
    }

    document.addEventListener('variant:update', function (event) {
      var detail = event.detail || {};
      var data = detail.data || {};
      var target = event.target;
      var root = (target && target.closest && target.closest('.shopify-section, dialog')) || document;

      root.querySelectorAll('product-price .ga-price').forEach(function (priceEl) {
        var host = priceEl.closest('product-price');
        if (!host) return;

        var targetProductId = target && target.dataset ? target.dataset.productId : null;
        if (!data.newProduct && targetProductId && host.dataset.productId !== targetProductId) return;

        if (data.newProduct && data.newProduct.id) {
          host.dataset.productId = String(data.newProduct.id);
        }

        var variantId = detail.resource && detail.resource.id;
        var map = data.newProduct ? null : readMap(host);

        if (map && variantId && map[variantId]) {
          apply(priceEl, map[variantId].price, map[variantId].compare);
          return;
        }

        if (data.html && data.html.querySelector) {
          var incoming =
            data.html.querySelector('product-price[data-block-id="' + host.dataset.blockId + '"] .ga-price') ||
            data.html.querySelector('product-price .ga-price');
          if (incoming) {
            priceEl.innerHTML = incoming.innerHTML;
            var incomingData = data.html.querySelector(
              'product-price[data-block-id="' + host.dataset.blockId + '"] script.ga-price-data'
            );
            var currentData = host.querySelector('script.ga-price-data');
            if (incomingData && currentData) currentData.textContent = incomingData.textContent;
          }
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
